(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.FoundiFunnelCore = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  function normalizePostalPrefix(value) {
    return String(value || '')
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, '')
      .slice(0, 3);
  }

  function isSampleEligible(value, prefixes) {
    const normalized = normalizePostalPrefix(value);
    return /^[A-Z]\d[A-Z]$/.test(normalized) && prefixes.includes(normalized);
  }

  function defaultPurchaseValue({ isSample, planIds }) {
    return !isSample && planIds.length ? planIds[0] : '';
  }

  function getCartUpsell(items, ids) {
    const variants = new Set(items.map((item) => String(item.variant_id)));
    if (variants.has(String(ids.duo))) return null;
    if (variants.has(String(ids.pouch))) {
      return { type: 'upgrade', fromVariantId: ids.pouch, variantId: ids.duo };
    }
    if (variants.has(String(ids.sample))) return { type: 'pouch', variantId: ids.pouch };
    return null;
  }

  return { normalizePostalPrefix, isSampleEligible, defaultPurchaseValue, getCartUpsell };
});
